import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, saveToken, clearToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [workspace, setWorkspace] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // Skip during Google OAuth callback
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setWorkspace(data.workspace);
    } catch {
      setUser(null);
      setWorkspace(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) saveToken(data.token);
    setUser(data.user);
    setWorkspace(data.workspace);
    return data;
  };

  const registerFirm = async (payload) => {
    const { data } = await api.post("/auth/register-firm", payload);
    if (data.token) saveToken(data.token);
    setUser(data.user);
    setWorkspace(data.workspace);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.debug("logout post failed (already signed out?)", err); }
    clearToken();
    setUser(null);
    setWorkspace(null);
  };

  return (
    <AuthContext.Provider value={{ user, workspace, loading, refresh, login, registerFirm, logout, setUser, setWorkspace }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
